export default "__VITE_ASSET__RVL_hzQE__"